export const grey1 = "#F6F8FA";
export const grey2 = "#D8E2EB";
export const grey3 = "#BEC1CC";
export const grey4 = "#373737";
export const blue = "#6247F5";
export const red = "#DE4040";

export const TOAST_TIME = 3000; // in milliseconds

export const MAX_PROJECTS = 10;
